'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n  background-color: transparent;\n  border-color: transparent;\n  color: ', ';\n  padding-left: 0;\n'], ['\n  ', '\n  background-color: transparent;\n  border-color: transparent;\n  color: ', ';\n  padding-left: 0;\n']);

exports.default = UIStatusTag;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UITag = require('./UITag');

var _UITag2 = _interopRequireDefault(_UITag);

var _renderProp = require('../utils/propTypes/renderProp');

var RenderProp = _interopRequireWildcard(_renderProp);

var _UIStatusDot = require('./UIStatusDot');

var _UIStatusDot2 = _interopRequireDefault(_UIStatusDot);

var _colors = require('HubStyleTokens/colors');

var _Styles = require('../utils/Styles');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var UnenclosedTag = (0, _styledComponents2.default)(_UITag2.default).withConfig({
  displayName: 'UIStatusTag__UnenclosedTag'
})(_templateObject, _Styles.FONT_FAMILIES.default, _colors.EERIE);

function UIStatusTag(_ref) {
  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      hollow = _ref.hollow,
      StatusDot = _ref.StatusDot,
      use = _ref.use,
      rest = _objectWithoutProperties(_ref, ['children', 'className', 'color', 'hollow', 'StatusDot', 'use']);

  return _react2.default.createElement(
    UnenclosedTag,
    _extends({
      use: use
    }, rest, {
      className: (0, _classNames2.default)('private-tag--unenclosed', className, {
        'private-tag--hollow': hollow
      })
    }),
    _react2.default.createElement(
      'span',
      { className: 'private-tag--unenclosed__text' },
      _react2.default.createElement(StatusDot, { color: color, hollow: hollow, use: use }),
      children
    )
  );
}

UIStatusTag.propTypes = _extends({}, _UITag2.default.propTypes, {
  color: _react.PropTypes.string,
  hollow: _react.PropTypes.bool.isRequired,
  StatusDot: RenderProp.getPropType(_UIStatusDot2.default).isRequired
});

UIStatusTag.defaultProps = _extends({}, _UITag2.default.defaultProps, {
  hollow: false,
  StatusDot: _UIStatusDot2.default,
  use: 'info'
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/tag/UIStatusTag.js
// module id = 1023
// module chunks = 2 3